import type { DocumentRepository } from '../../application/DocumentRepository'
import type { DocumentDataSource } from '../../domain/document'

/**
 * Aucune archive n'est simulée : un document n'existe que lorsqu'un envoi réel a
 * produit son PDF, sa preuve SHA-256 et ses liens. Le mode fixtures affiche donc
 * un état vide explicite plutôt qu'un document inventé.
 */
export function createFixtureDocumentRepository(source: DocumentDataSource = 'fixtures'): DocumentRepository {
  return {
    listForEntity() {
      return Promise.resolve({
        documents: [],
        meta: { source, retrievedAt: new Date().toISOString() },
      })
    },
    createDownloadUrl() {
      return Promise.reject(new Error('DOCUMENT_DOWNLOAD_SUPABASE_REQUIRED'))
    },
    uploadClientDocument() {
      return Promise.reject(new Error('CLIENT_DOCUMENT_UPLOAD_SUPABASE_REQUIRED'))
    },
    uploadPaymentDocument() {
      return Promise.reject(new Error('PAYMENT_DOCUMENT_UPLOAD_SUPABASE_REQUIRED'))
    },
  }
}
